import { render, staticRenderFns } from "./accept-all-notifications.vue?vue&type=template&id=c0d009f4"
import script from "./accept-all-notifications.vue?vue&type=script&lang=js"
export * from "./accept-all-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports